import { InjectionToken } from '@angular/core';
import { type CollabServerConfig } from './providers/collab-provider-base';

export const COLLAB_SERVER_CONFIG = new InjectionToken<CollabServerConfig>(
  'BD_COLLAB_SERVER_CONFIG',
);
export const COLLAB_READY_RACE_TIME = new InjectionToken<number>(
  'COLLAB_READY_RACE_TIME',
);
export const NETWORK_STATE_OFFLINE_INTERVAL = new InjectionToken<number>(
  'NETWORK_STATE_OFFLINE_INTERVAL',
);
